module.exports = __webpack_public_path__ + "static/invoice-automation-a374e8a461b8dc2d74d91a3f968c9f7b.png";